import { Tool } from '../types'

export const tools: Tool[] = [
  {
    id: 'json-formatter',
    name: 'JSON 格式化工具',
    description: '在浏览器本地完成 JSON 格式化、压缩、校验和错误定位，数据不会上传服务器。',
    icon: 'Braces',
    category: '开发工具',
    categorySlug: 'developer',
    path: '/tool/json-formatter',
    status: 'ready',
    badge: '本地处理',
    seoTitle: 'JSON 格式化工具 - 在线 JSON 校验、压缩与美化',
    seoDescription: '免费的在线 JSON 格式化工具，支持 JSON 美化、压缩、校验和错误定位，数据在浏览器本地处理。',
    keywords: ['JSON 格式化', 'JSON 校验', 'JSON 压缩'],
    relatedToolIds: ['timestamp-converter', 'base64-codec', 'url-codec']
  },
  {
    id: 'timestamp-converter',
    name: '时间戳转换',
    description: 'Unix 时间戳与本地时间互转，支持秒、毫秒和当前时间快速填充。',
    icon: 'Clock',
    category: '开发工具',
    categorySlug: 'developer',
    path: '/tool/timestamp-converter',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '时间戳转换工具 - Unix 时间戳与日期互转',
    seoDescription: '在线时间戳转换工具，支持秒级、毫秒级 Unix 时间戳和本地日期时间互转。',
    keywords: ['时间戳转换', 'Unix 时间戳', '毫秒时间戳'],
    relatedToolIds: ['json-formatter', 'url-codec', 'base64-codec']
  },
  {
    id: 'base64-codec',
    name: 'Base64 编解码',
    description: '文本 Base64 编码和解码，适合处理配置、令牌片段和调试数据。',
    icon: 'Binary',
    category: '开发工具',
    categorySlug: 'developer',
    path: '/tool/base64-codec',
    status: 'ready',
    badge: '本地处理',
    seoTitle: 'Base64 编解码 - 在线 Base64 编码和解码工具',
    seoDescription: '免费的 Base64 编解码工具，支持文本 Base64 编码、解码和调试，内容仅在浏览器本地处理。',
    keywords: ['Base64 编码', 'Base64 解码', 'Base64 在线工具'],
    relatedToolIds: ['url-codec', 'json-formatter', 'timestamp-converter']
  },
  {
    id: 'url-codec',
    name: 'URL 编解码',
    description: '对 URL、查询参数和中文字符进行 encodeURIComponent 编码与解码。',
    icon: 'Link2',
    category: '开发工具',
    categorySlug: 'developer',
    path: '/tool/url-codec',
    status: 'ready',
    badge: '本地处理',
    seoTitle: 'URL 编解码工具 - 在线 URL Encode 和 Decode',
    seoDescription: '在线 URL 编解码工具，支持链接、查询参数、中文字符的 encodeURIComponent 编码与解码。',
    keywords: ['URL 编码', 'URL 解码', 'URL Encode'],
    relatedToolIds: ['base64-codec', 'json-formatter', 'qr-code-generator']
  },
  {
    id: 'regex-tester',
    name: '正则测试',
    description: '输入正则和文本，实时查看匹配结果、分组与常用 flags 效果。',
    icon: 'Regex',
    category: '开发工具',
    categorySlug: 'developer',
    path: '/tool/regex-tester',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '正则测试工具 - 在线正则表达式匹配测试',
    seoDescription: '在线正则表达式测试工具，支持实时查看匹配结果、分组和常用 flags 效果。',
    keywords: ['正则测试', '正则表达式', 'Regex Tester'],
    relatedToolIds: ['json-formatter', 'text-toolbox', 'url-codec']
  },
  {
    id: 'image-metadata',
    name: '图片元信息',
    description: '读取图片尺寸、类型和 EXIF 信息，支持清除元信息并修改 JPEG 常用描述字段。',
    icon: 'Image',
    category: '图片工具',
    categorySlug: 'image',
    path: '/tool/image-metadata',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '图片元信息查看器 - 在线查看和清除 EXIF 信息',
    seoDescription: '在线图片元信息工具，支持查看图片尺寸、文件类型和 EXIF 信息，并可清除常见元数据。',
    keywords: ['图片 EXIF', '图片元信息', '清除图片信息'],
    relatedToolIds: ['image-compressor', 'image-resizer', 'image-format-converter']
  },
  {
    id: 'image-compressor',
    name: '图片压缩',
    description: '调整图片质量或压缩到指定 KB，支持 JPG、PNG、WebP 等常见图片。',
    icon: 'Minimize2',
    category: '图片工具',
    categorySlug: 'image',
    path: '/tool/image-compressor',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '图片压缩工具 - 免费在线压缩图片到指定 KB',
    seoDescription: '免费在线图片压缩工具，支持按质量压缩图片、压缩图片到指定 KB，JPG、PNG、WebP 在浏览器本地处理。',
    keywords: ['图片压缩', '压缩图片到指定大小', '图片压缩到 200KB'],
    relatedToolIds: ['image-resizer', 'image-format-converter', 'image-to-webp']
  },
  {
    id: 'batch-image-compressor',
    name: '图片批量压缩',
    description: '一次上传多张图片并统一压缩质量，可选统一最大宽度后批量下载单张或 ZIP。',
    icon: 'Archive',
    category: '图片工具',
    categorySlug: 'image',
    path: '/tool/batch-image-compressor',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '图片批量压缩 - 在线批量压缩多张图片',
    seoDescription: '免费在线图片批量压缩工具，支持一次上传多张图片、统一压缩质量、可选统一最大宽度，并下载单张或 ZIP，处理过程在浏览器本地完成。',
    keywords: ['图片批量压缩', '批量压缩图片', '多张图片压缩'],
    relatedToolIds: ['image-compressor', 'image-resizer', 'image-format-converter', 'image-watermark']
  },
  {
    id: 'image-watermark',
    name: '图片加水印',
    description: '给图片添加文字水印，可调整位置、透明度、字号和颜色，图片在浏览器本地处理。',
    icon: 'BadgeCheck',
    category: '图片工具',
    categorySlug: 'image',
    path: '/tool/image-watermark',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '图片加水印 - 在线给图片添加文字水印',
    seoDescription: '免费在线图片加水印工具，支持设置文字、位置、透明度和颜色，图片在浏览器本地处理。',
    keywords: ['图片加水印', '照片加水印', '在线水印工具'],
    relatedToolIds: ['image-compressor', 'image-resizer', 'image-cropper', 'image-format-converter']
  },
  {
    id: 'image-to-webp',
    name: '图片转 WebP',
    description: '将图片转换为 WebP 格式，适合网页图片优化和减小体积。',
    icon: 'Repeat',
    category: '图片工具',
    categorySlug: 'image',
    path: '/tool/image-to-webp',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '图片转 WebP - 在线 JPG、PNG 转 WebP 工具',
    seoDescription: '在线图片转 WebP 工具，支持将 JPG、PNG 等常见图片转换为 WebP 格式以优化网页体积。',
    keywords: ['图片转 WebP', 'JPG 转 WebP', 'PNG 转 WebP'],
    relatedToolIds: ['image-format-converter', 'image-compressor', 'image-resizer']
  },
  {
    id: 'image-resizer',
    name: '图片尺寸调整',
    description: '按指定宽高缩放图片，可选择保持比例并导出新图片。',
    icon: 'Maximize2',
    category: '图片工具',
    categorySlug: 'image',
    path: '/tool/image-resizer',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '图片尺寸调整 - 在线修改图片宽高',
    seoDescription: '免费的图片尺寸调整工具，支持按指定宽高缩放图片、保持比例并导出新图片。',
    keywords: ['图片尺寸调整', '修改图片大小', '图片缩放'],
    relatedToolIds: ['image-compressor', 'image-cropper', 'image-format-converter']
  },
  {
    id: 'image-cropper',
    name: '图片裁剪',
    description: '上传图片后拖拽裁剪区域，在线导出裁剪后的图片。',
    icon: 'Crop',
    category: '图片工具',
    categorySlug: 'image',
    path: '/tool/image-cropper',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '图片裁剪工具 - 在线裁剪图片',
    seoDescription: '免费的在线图片裁剪工具，支持上传图片、选择裁剪区域并导出裁剪后的图片。',
    keywords: ['图片裁剪', '在线裁剪图片', '裁剪照片'],
    relatedToolIds: ['image-resizer', 'image-compressor', 'image-format-converter']
  },
  {
    id: 'id-photo-cropper',
    name: '证件照尺寸裁剪',
    description: '按一寸、二寸、小一寸或自定义尺寸裁剪证件照，并导出指定像素图片。',
    icon: 'ScanFace',
    category: '图片工具',
    categorySlug: 'image',
    path: '/tool/id-photo-cropper',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '证件照尺寸裁剪 - 在线裁剪一寸二寸照片',
    seoDescription: '免费在线证件照尺寸裁剪工具，支持一寸、二寸、小一寸和自定义尺寸导出。',
    keywords: ['证件照尺寸', '一寸照片裁剪', '二寸照片裁剪'],
    relatedToolIds: ['image-cropper', 'image-resizer', 'image-compressor', 'image-format-converter']
  },
  {
    id: 'image-format-converter',
    name: '图片格式转换',
    description: '将图片转换为 JPG、PNG 或 WebP 格式，适合网页优化和日常办公。',
    icon: 'RefreshCw',
    category: '图片工具',
    categorySlug: 'image',
    path: '/tool/image-format-converter',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '图片格式转换 - 在线 PNG、JPG、WebP 互转',
    seoDescription: '免费的在线图片格式转换工具，支持将图片转换为 JPG、PNG 或 WebP，处理过程不上传服务器。',
    keywords: ['图片格式转换', 'PNG 转 JPG', 'JPG 转 WebP'],
    relatedToolIds: ['image-to-webp', 'image-compressor', 'image-resizer']
  },
  {
    id: 'images-to-pdf',
    name: '图片转 PDF',
    description: '把多张图片按顺序合成为一个 PDF 文件。',
    icon: 'FilePlus2',
    category: 'PDF 工具',
    categorySlug: 'pdf',
    path: '/tool/images-to-pdf',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '图片转 PDF - 在线多张图片合成 PDF',
    seoDescription: '免费的图片转 PDF 工具，支持多张图片按顺序合成为一个 PDF 文件，浏览器本地处理。',
    keywords: ['图片转 PDF', 'JPG 转 PDF', '多图合成 PDF'],
    relatedToolIds: ['pdf-merge', 'pdf-split', 'pdf-to-images']
  },
  {
    id: 'pdf-merge',
    name: 'PDF 合并',
    description: '选择多个 PDF，按顺序合并为一个文件。',
    icon: 'FileText',
    category: 'PDF 工具',
    categorySlug: 'pdf',
    path: '/tool/pdf-merge',
    status: 'ready',
    badge: '本地处理',
    seoTitle: 'PDF 合并工具 - 在线合并多个 PDF 文件',
    seoDescription: '免费的在线 PDF 合并工具，支持选择多个 PDF 并按顺序合并为一个文件。',
    keywords: ['PDF 合并', '合并 PDF', '多个 PDF 合成'],
    relatedToolIds: ['pdf-split', 'images-to-pdf', 'pdf-to-images']
  },
  {
    id: 'pdf-compressor',
    name: 'PDF 压缩',
    description: '在线优化 PDF 文件大小，适合上传前减小文档体积，处理过程不上传服务器。',
    icon: 'Archive',
    category: 'PDF 工具',
    categorySlug: 'pdf',
    path: '/tool/pdf-compressor',
    status: 'ready',
    badge: '本地处理',
    seoTitle: 'PDF 压缩工具 - 免费在线压缩 PDF 文件大小',
    seoDescription: '免费在线 PDF 压缩工具，适合上传前减小文档体积，支持浏览器本地压缩 PDF 文件大小，不上传服务器。',
    keywords: ['PDF 压缩', '压缩 PDF', 'PDF 文件变小'],
    relatedToolIds: ['pdf-merge', 'pdf-split', 'pdf-to-images', 'images-to-pdf']
  },
  {
    id: 'pdf-rotate',
    name: 'PDF 页面旋转',
    description: '在线旋转 PDF 页面方向，支持全部页面或指定页码左转、右转和旋转 180 度。',
    icon: 'RotateCw',
    category: 'PDF 工具',
    categorySlug: 'pdf',
    path: '/tool/pdf-rotate',
    status: 'ready',
    badge: '本地处理',
    seoTitle: 'PDF 页面旋转 - 在线旋转 PDF 页面方向',
    seoDescription: '免费在线 PDF 页面旋转工具，支持全部页面或指定页码左转、右转和旋转 180 度，文件在浏览器本地处理。',
    keywords: ['PDF 旋转', '旋转 PDF 页面', 'PDF 页面方向'],
    relatedToolIds: ['pdf-split', 'pdf-merge', 'pdf-compressor', 'pdf-to-images']
  },
  {
    id: 'pdf-split',
    name: 'PDF 拆分',
    description: '选择一个 PDF，按页码范围导出新的 PDF 文件。',
    icon: 'Scissors',
    category: 'PDF 工具',
    categorySlug: 'pdf',
    path: '/tool/pdf-split',
    status: 'ready',
    badge: '本地处理',
    seoTitle: 'PDF 拆分工具 - 在线按页码拆分 PDF',
    seoDescription: '免费的在线 PDF 拆分工具，支持按页码范围从 PDF 中导出新的 PDF 文件。',
    keywords: ['PDF 拆分', 'PDF 分割', '提取 PDF 页面'],
    relatedToolIds: ['pdf-merge', 'images-to-pdf', 'pdf-to-images', 'pdf-rotate', 'pdf-text-extractor']
  },
  {
    id: 'pdf-text-extractor',
    name: 'PDF 提取文字',
    description: '从带文本层的 PDF 中提取纯文本，支持复制和下载 TXT。',
    icon: 'FileSearch',
    category: 'PDF 工具',
    categorySlug: 'pdf',
    path: '/tool/pdf-text-extractor',
    status: 'ready',
    badge: '本地处理',
    seoTitle: 'PDF 提取文字 - 在线从 PDF 中提取文本',
    seoDescription: '免费在线 PDF 提取文字工具，支持从带文本层的 PDF 中提取纯文本，复制或下载 TXT，文件在浏览器本地处理。',
    keywords: ['PDF 提取文字', 'PDF 转文本', 'PDF 提取文本'],
    relatedToolIds: ['pdf-ocr-text-extractor', 'pdf-to-images', 'pdf-split', 'pdf-merge']
  },
  {
    id: 'pdf-ocr-text-extractor',
    name: '扫描 PDF OCR 文字识别',
    description: '用 OCR 识别扫描版或图片型 PDF 中的文字，支持复制和下载 TXT。',
    icon: 'FileScan',
    category: 'PDF 工具',
    categorySlug: 'pdf',
    path: '/tool/pdf-ocr-text-extractor',
    status: 'ready',
    badge: 'OCR',
    seoTitle: 'PDF OCR 文字识别 - 扫描 PDF 转可复制文本',
    seoDescription: '免费的 PDF OCR 文字识别工具，支持扫描 PDF、图片型 PDF 识别文字并导出 TXT，适合处理不可复制的扫描件。',
    keywords: ['PDF OCR', '扫描 PDF 识别文字', '图片型 PDF 转文字'],
    relatedToolIds: ['pdf-text-extractor', 'pdf-to-images', 'pdf-split', 'pdf-merge']
  },
  {
    id: 'pdf-to-images',
    name: 'PDF 转图片',
    description: '将 PDF 页面导出为 PNG 图片，适合分享、预览和办公处理。',
    icon: 'FileImage',
    category: 'PDF 工具',
    categorySlug: 'pdf',
    path: '/tool/pdf-to-images',
    status: 'ready',
    badge: '本地处理',
    seoTitle: 'PDF 转图片 - 在线 PDF 转 PNG 图片',
    seoDescription: '免费的 PDF 转图片工具，支持把 PDF 页面导出为 PNG 图片，处理过程在浏览器本地完成。',
    keywords: ['PDF 转图片', 'PDF 转 PNG', 'PDF 转 JPG'],
    relatedToolIds: ['images-to-pdf', 'pdf-merge', 'pdf-split', 'pdf-rotate', 'pdf-text-extractor']
  },
  {
    id: 'qr-code-generator',
    name: '二维码生成器',
    description: '输入文本或链接，在浏览器本地生成二维码并下载 PNG 图片。',
    icon: 'QrCode',
    category: '文本工具',
    categorySlug: 'text',
    path: '/tool/qr-code-generator',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '二维码生成器 - 在线生成 URL 和文本二维码',
    seoDescription: '免费的在线二维码生成器，支持把链接、文本和常用内容生成二维码 PNG，处理过程在浏览器本地完成。',
    keywords: ['二维码生成器', '在线二维码', 'URL 生成二维码'],
    relatedToolIds: ['text-toolbox', 'url-codec']
  },
  {
    id: 'text-toolbox',
    name: '文本工具箱',
    description: '统计字数、清理空行、文本去重和大小写转换，适合日常办公处理。',
    icon: 'TextCursorInput',
    category: '文本工具',
    categorySlug: 'text',
    path: '/tool/text-toolbox',
    status: 'ready',
    badge: '本地处理',
    seoTitle: '文本工具箱 - 在线字数统计、文本去重和大小写转换',
    seoDescription: '免费的在线文本工具箱，支持字数统计、删除重复行、清理空行、大小写转换和空格整理。',
    keywords: ['字数统计', '文本去重', '大小写转换'],
    relatedToolIds: ['qr-code-generator', 'regex-tester', 'url-codec']
  },
  {
    id: 'clipboard-share',
    name: '跨设备剪切板',
    description: '创建临时文本剪切板，用访问码在手机、电脑等设备之间共享内容。',
    icon: 'Share2',
    category: '文本工具',
    categorySlug: 'text',
    path: '/tool/clipboard-share',
    status: 'ready',
    badge: '临时共享',
    seoTitle: '跨设备剪切板 - 手机电脑临时共享文本',
    seoDescription: '免费的跨设备剪切板工具，生成访问码后可在手机和电脑之间临时共享文本内容。',
    keywords: ['跨设备剪切板', '临时剪切板', '手机电脑传文字'],
    relatedToolIds: ['text-toolbox', 'qr-code-generator', 'url-codec']
  },
  {
    id: 'parent-resource-dashboard',
    name: '家长资源驾驶舱',
    description: '集中整理家长课堂、讲座和育儿学习资源，支持筛选、收藏、状态标记和个人笔记。',
    icon: 'BookOpenCheck',
    category: '家庭教育',
    categorySlug: 'family',
    path: '/tool/parent-resource-dashboard',
    status: 'ready',
    badge: '本地整理',
    seoTitle: '家长资源驾驶舱 - 家庭教育资源整理与收藏工具',
    seoDescription: '集中整理家庭教育资源、家长课堂、讲座和育儿学习内容，支持按主题筛选、收藏、状态标记和个人笔记，方便家长随时回看。',
    keywords: ['家长课堂整理', '育儿资源整理', '家庭教育资源'],
    relatedToolIds: ['growth-assessment', 'text-toolbox', 'clipboard-share']
  },
  {
    id: 'nasdaq-tracker',
    name: '纳斯达克定投看板',
    description: '跟踪纳指估值、趋势、回撤和 ETF 溢价，用一套评分体系辅助定投节奏判断。',
    icon: 'TrendingUp',
    category: '投资看板',
    categorySlug: 'investment',
    path: '/nsdq',
    status: 'external',
    badge: '实时数据',
    externalUrl: '/nsdq',
    seoTitle: '纳斯达克定投看板 - Parentool 工具站',
    seoDescription: '跟踪纳指估值、趋势、回撤和 ETF 溢价，用评分体系辅助定投节奏判断。',
    keywords: ['纳斯达克定投', '纳指估值', 'ETF 溢价'],
    relatedToolIds: []
  },
  {
    id: 'growth-assessment',
    name: '儿童身高体重评估',
    description: '根据国家儿童发育标准，评估孩子的身高体重发育情况，提供专业的图表分析和发育建议。',
    icon: 'Baby',
    category: '健康评估',
    categorySlug: 'health',
    path: '/tool/growth-assessment',
    status: 'ready',
    seoTitle: '儿童身高体重评估 - 在线儿童生长发育评估工具',
    seoDescription: '根据儿童发育标准评估身高体重情况，提供百分位、图表分析和发育建议。',
    keywords: ['儿童身高体重', '生长发育评估', '儿童百分位'],
    relatedToolIds: []
  }
]
